import React, { useState, useEffect } from 'react';
import Pagination from "react-js-pagination";
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,

  Heading,
  Flex,
  Center
} from '@chakra-ui/react'
import { Input } from '@chakra-ui/react';
import {  } from '@chakra-ui/icons';
import { ChevronDownIcon } from '@chakra-ui/icons'
import { fetchWrapper } from '../helpers';
import moment from 'moment';
import Header from '../components/Header'
import { getUserFromToken } from '../components/authHelper';
import { useLocation } from 'react-router-dom';
import API from '../helpers/axiosInstance';
import { getApiHeaders, hasPermission } from '../utils/DefaultFunction';
import { LuReceipt } from 'react-icons/lu';
import PageHeading from '../components/shared/PageHeading';

function List() {
  const [list, setList] = useState([])
  const [listTrans, setListTrans] = useState([])
  const [date, setDate] = useState('')

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [listCount, setListCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');

  const location = useLocation();
  const [featurePermissions, setFeaturePermissions] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(true);
  const permParams = location.pathname.replace('/', "");

  const fetchPermissions = async () => {
    setPermissionsLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}/permission/feature/list?slug=${permParams}`;
      const response = await API.get(url, { headers: getApiHeaders() });
      setFeaturePermissions(response.data.data || []);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setFeaturePermissions([]);
    } finally {
      setPermissionsLoading(false);
    }
  };
  useEffect(() => {
    fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const billingViewPermission = hasPermission("billing-view", featurePermissions);

  useEffect(() => {
    const user = getUserFromToken();
    const id = user.customer_id
    loadTrans(id, date, searchValue);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date])

  const loadTrans = async (id, date = "", searchValue = "") => {
    setLoading(true)
    const formattedDate = date ? moment(date).format('YYYY-MM-DD') : "";
    const url = `${process.env.REACT_APP_API_URL}/transaction/list?date=${formattedDate}&message_id=${searchValue}`;
    const data = await fetchWrapper.get(url)
    setListTrans(data)
    setList(data.data)

    setListCount(data.count)
    setLoading(false)
  }

  const onChangePaginate = (pageNumber) => {
    setActivePage(pageNumber);
    // to set offset

  };



  const handleSearchClick = () => {
    const user = getUserFromToken();
    const id = user.customer_id;
    loadTrans(id, date, searchValue);
    // setSearchValue('')
  };

  const clearSearch = () => {
    const user = getUserFromToken();
    const id = user.customer_id;

    setSearchValue('')
    loadTrans(id, date);
  };


  if (permissionsLoading) {
    return (
      <>
        <Header />
        <Center h="400px">
          <Spinner size="xl" color="blue.500" thickness="4px" />
        </Center>
      </>
    );
  }

  return (
    <>

      {loading &&
        <HStack width="100%" h="100vh" top="0" left="0" bg="rgba(204, 204, 204, 0.5)" position="absolute" zIndex="9999" justifyContent="center">
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.500'
            size='xl'
          />
        </HStack>
      }
      <Header />
      {billingViewPermission ? (
      <div className="body_section">


        <PageHeading icon={LuReceipt} title="Billing" mb={6}>
          <Box w="395px">
            {/* <InputGroup>
              <Input type="text" placeholder="Search using Message ID or Phone No"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />

              <InputRightElement width="unset">
                <IconButton
                  aria-label="Search"
                  icon={<SearchIcon color="gray.300" />}
                  onClick={handleSearchClick}
                  variant="link"
                  pointerEvents="auto"
                />
                <IconButton
                  aria-label="Clear"
                  icon={<CloseIcon color="gray.300" />}
                  onClick={clearSearch}
                  variant="link"
                  pointerEvents="auto"
                />
              </InputRightElement>

            </InputGroup> */}
          </Box>
          <Box>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          </Box>
        </PageHeading>


        <Box className="analytics_panel_section">
          <HStack mb="30px" >
            <Box className="analytics_box_section">
              <Heading>€ {listTrans?.totalCR?.toFixed(4) || 0}</Heading>

              <Text>Total Top-up <span>(Till Date)</span></Text>
            </Box>

            <Box className="analytics_box_section">
              <Heading>€ {listTrans?.totalDR?.toFixed(4)}</Heading>

              <Text>Total Used <span>(Till Date)</span></Text>
            </Box>

            <Box className="analytics_box_section">
              <Heading>€ {listTrans?.total?.toFixed(4)}</Heading>

              <Text>Current Balance</Text>
            </Box>
          </HStack>
        </Box>


        <div className="table_section">
          <TableContainer width="100%">
            <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
              <Thead >
                <Tr>
                  <Th>Customer</Th>
                  <Th>Transcition Descpition</Th>
                  <Th>Transcition Type</Th>
                  <Th>Amount </Th>

                  <Th>Status</Th>
                  <Th>Date</Th>
                  <Th></Th>






                </Tr>
              </Thead>

              <Tbody fontSize="14px">
                {list.map((rs, index) => {
                  return (

                    <Tr key={rs?.id || index}>
                      <Td>{rs?.Customer?.business_name}</Td>

                      <Td>{rs.trans_desc}</Td>
                      <Td>{rs.trans_type}</Td>
                      <Td>{rs.amount}</Td>


                      <Td>
                        <div style={{ color: rs?.Status?.color }}>{rs?.Status?.msg_status == 0 ? 'Failed' : 'Success'}</div>
                        {rs?.Status?.name}
                      </Td>

                      <Td>{moment(rs.created_at).format('DD MMMM YYYY')}</Td>

                      <Td style={{ color: "#0000EE" }}>
                        <Menu>
                          <MenuButton fontSize="14px" >
                            Action

                            <ChevronDownIcon />
                          </MenuButton>

                          <MenuList style={{ minWidth: "20px", border: "1px solid #CCCCCC" }}>
                            <MenuItem h="16px" fontSize="12px">Edit</MenuItem>
                            <MenuDivider />
                            <MenuItem h="16px" fontSize="12px"  >Editable</MenuItem>

                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>

                  )
                })}





              </Tbody>


            </Table>
            <Flex justifyContent="center" alignItems="center" >
              <Pagination
                activePage={activePage}
                itemsCountPerPage={100}
                totalItemsCount={listCount}
                pageRangeDisplayed={5}
                onChange={onChangePaginate}
                innerClass="pagination"
                itemClass="page-item"
                activeLinkClass="page-link active"
                linkClass="page-link"
              
              />
            </Flex>
          </TableContainer>
        </div>
      </div>
      ) : (
        <Center h="400px">
          <Box textAlign="center">
            <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
              No Access
            </Text>
            <Text fontSize="sm" color="gray.500">
              You don't have permission to view this sections.
            </Text>
          </Box>
        </Center>
      )}
    </>
  )
}

export default List;